<div class="tabs">
  <div (click)="switchTab(tab)"
       *ngFor="let tab of tabList"
       [class.active-tab]="currentTab?.key === tab.key"
       [class.disabled]="tab.disabled"
       [hidden]="tab.hidden"
       class="tab">{{tab.value | translate}}<span *ngIf="tab.postfix">{{tab.postfix}}</span></div>
</div>
